import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { DwtStore } from './types'

export const useDwtStore = create<DwtStore>()(
    devtools(
        (set) => ({
            dwo: undefined,
            bufferImageIds: [],
            pagesFormState: {},
            imageHrefs: new Map(),
            imageSrcs: new Map(),
            barcodes: new Map(),
            blanks: new Map(),
            settings: {
                autoCatalog: false,
                barcodeReader: true,
                blankPageSeparator: true,
                ignoreBlankPages: false,
            },

            computedDocs: [],

            // Utilities
            namedSet: set, // https://github.com/pmndrs/zustand/issues/517
        }),
        { name: 'DwtStore', serialize: { options: true } },
    ),
)

export const setDwo = (dwo: DwtStore['dwo']) => useDwtStore.setState({ dwo })

export const useStore = useDwtStore
export default useDwtStore
